import React from 'react'
import styles from './BlueImageIconsBox.module.sass'
import { MenuItemType } from '@next-nx/utils/types'
import { WContainer, WImage } from '@next-nx/shared-ui/atoms'
import { IconTextDescriptionItem } from '@next-nx/shared-ui/molecules'

interface Props {
  className?: string
  item?: MenuItemType
}

const BlueImageIconsBox = (props: Props) => {
  const { className = '', item = undefined } = props

  return (
    <div className={`${styles.root} ${className}`}>
      <WContainer>
      <div className={styles.imageBox}>
        <WImage
          maxWidth={506}
          maxHeight={425}
          className={styles.image}
          src={item?.image}
          objectFit={'cover'}
          layout={'intrinsic'}
        />
      </div>
      <div className={styles.layout}>
        {!!item?.name && <div className={styles.name}>{item?.name}</div>}
        <div className={`${styles.content} ${styles['content--1']}`}>
          {item?.children?.edges?.slice(0, 4).map((x, index) => (
            <div className={styles.item}>
              <IconTextDescriptionItem item={x?.node} className={styles.item} />
            </div>
          ))}
        </div>
        <div className={`${styles.content} ${styles['content--2']}`}>
          {item?.children?.edges?.slice(4, 7).map((x, index) => (
            <div className={styles.item}>
              <IconTextDescriptionItem item={x?.node} className={styles.item} />
            </div>
          ))}
        </div>
      </div>
      </WContainer>
    </div>
  )
}

export default BlueImageIconsBox
